module.exports = __webpack_public_path__ + "img/hopways-03.81cd6640.jpeg";